/**
 * This file is intended for specific values that are used across the frontend application.
 * 
 * @file constants.ts
 */

export type NavItem<Args extends unknown[] = []> = {
  title: string;
  path: (...args: Args) => string;
};

export const routes = {
  ClientHistory: {
    title: 'Client History',
    path: () => '/',
  } satisfies NavItem,
  PredictedDiagnoses: {
    title: 'Predicted Diagnoses',
    path: () => '/predictions',
  } satisfies NavItem,
  ConfirmationTests: {
    title: 'Confirmation Tests',
    path: () => '/tests',
  } satisfies NavItem,
  DsmAssociations: {
    title: 'DSM-5 Associations',
    path: (diagnosisName?: string) => (
      '/dsm5-associations' +
      (diagnosisName ? `?diagnosis=${encodeURIComponent(diagnosisName)}` : '')
    ),
  } satisfies NavItem,
  DsmReference: {
    title: 'DSM-5 Reference',
    path: () => '/dsm5-reference',
  } satisfies NavItem,
} as const;

export const routeNames: Record<string, string> = {
  ClientHistory: 'Client History',
  PredictedDiagnoses: 'Predicted Diagnoses',
  ConfirmationTests: 'Confirmation Tests',
  DsmAssociations: 'DSM-5 Associations',
  DsmReference: 'DSM-5 Reference',
} as const;



